export class BluechatTemplate {
  name: string;
  message: string;
  domain: string;
  category: string;

  static fromDto(templateJson: any) {
    const res = new BluechatTemplate();

    res.name = templateJson.name;
    res.message = templateJson.message;
    res.domain = templateJson.domain;
    res.category = templateJson.category;

    return res;
  }
}
